export const NAME = "settings";
